export default {"src":"/_next/static/media/humanIcon.74b81df8.svg","height":9,"width":10,"blurWidth":0,"blurHeight":0};